import React from 'react';
import styles from './Body.module.scss';
import cn from 'classnames';

const Body = ({ children, classname = '' }) => {
  return <div className={cn(styles.root, classname)}>{children}</div>;
};

export default Body;
